export enum VIEW {
  YEAR,
  MONTH,
}
